(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["calendly"] && !Shopify.designMode) return;
  try {
    (function () {
    function loadCalendlyAssets(callback) {
      if (window.Calendly) {
        callback();
        return;
      }

      if (!document.querySelector('link[data-calendly-widget-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        link.setAttribute('data-calendly-widget-css', 'true');
        document.head.appendChild(link);
      }

      var existing = document.querySelector('script[data-calendly-widget-js]');
      if (existing) {
        existing.addEventListener('load', callback);
        if (window.Calendly) callback();
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.setAttribute('data-calendly-widget-js', 'true');
      script.onload = callback;
      document.head.appendChild(script);
    }

    function initBlock(root) {
      if (!root || root.getAttribute('data-calendly-ready') === 'true') return;

      var url = root.getAttribute('data-calendly-url');
      var type = root.getAttribute('data-calendly-embed-type') || 'inline';
      if (!url) return;

      loadCalendlyAssets(function () {
        if (!window.Calendly) return;

        if (type === 'inline') {
          var host = root.querySelector('[data-calendly-inline]');
          if (!host || host.getAttribute('data-initialized') === 'true') return;
          if (window.Calendly.initInlineWidget) {
            window.Calendly.initInlineWidget({ url: url, parentElement: host });
            host.setAttribute('data-initialized', 'true');
          }
        } else if (type === 'popup_widget') {
          if (root.getAttribute('data-badge-initialized') === 'true') return;
          if (window.Calendly.initBadgeWidget) {
            window.Calendly.initBadgeWidget({
              url: url,
              text: root.getAttribute('data-calendly-badge-text') || 'Schedule a call',
              color: root.getAttribute('data-calendly-badge-color') || '#0D493F',
              textColor: root.getAttribute('data-calendly-badge-text-color') || '#F5F0E6'
            });
            root.setAttribute('data-badge-initialized', 'true');
          }
        } else if (type === 'popup_text') {
          var button = root.querySelector('[data-calendly-popup-text]');
          if (!button || button.getAttribute('data-bound') === 'true') return;
          button.addEventListener('click', function () {
            if (window.Calendly && window.Calendly.initPopupWidget) {
              window.Calendly.initPopupWidget({ url: url });
            }
          });
          button.setAttribute('data-bound', 'true');
        }

        root.setAttribute('data-calendly-ready', 'true');
      });
    }

    function initAll() {
      document.querySelectorAll('[data-calendly-block]').forEach(initBlock);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-field"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-travel-dates]').forEach((group) => {
    if (group.dataset.bound === 'true') return;
    group.dataset.bound = 'true';

    const start = group.querySelector('[data-travel-date-start]');
    const end = group.querySelector('[data-travel-date-end]');
    const hidden = group.querySelector('[data-travel-date-value]');
    if (!start || !end || !hidden) return;

    const sync = () => {
      if (start.value) {
        end.min = start.value;
        if (end.value && end.value < start.value) end.value = start.value;
      }
      if (start.value && end.value) {
        hidden.value = start.value + ' – ' + end.value;
      } else {
        hidden.value = start.value || end.value || '';
      }
    };

    start.addEventListener('change', sync);
    end.addEventListener('change', sync);
    group.closest('form')?.addEventListener('submit', sync);
  });

  document.querySelectorAll('[data-appointment-picker]').forEach((picker) => {
    if (picker.dataset.bound === 'true') return;
    picker.dataset.bound = 'true';

    const dateInput = picker.querySelector('[data-appointment-date]');
    const dayLabel = picker.querySelector('[data-appointment-day-label]');
    if (!dateInput || !dayLabel) return;

    const formatDay = () => {
      if (!dateInput.value) {
        dayLabel.textContent = '';
        return;
      }
      const parts = dateInput.value.split('-').map(Number);
      const date = new Date(parts[0], parts[1] - 1, parts[2]);
      dayLabel.textContent = date.toLocaleDateString(undefined, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      });
    };

    dateInput.addEventListener('change', formatDay);
    formatDay();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["meeting-schedule"] && !Shopify.designMode) return;
  try {
    (function () {
    var routesCartUpdate = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/update.js'
      : '/cart/update.js';
    var routesCart = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js';

    function initPicker(root) {
      if (!root || root.getAttribute('data-meeting-ready') === 'true') return;
      root.setAttribute('data-meeting-ready', 'true');

      var dateInput = root.querySelector('[data-meeting-date]');
      var dayLabel = root.querySelector('[data-meeting-day-label]');
      var calendarEl = root.querySelector('[data-meeting-calendar]');
      var calTitle = root.querySelector('[data-meeting-cal-title]');
      var calGrid = root.querySelector('[data-meeting-cal-grid]');
      var calWeekdays = root.querySelector('[data-meeting-cal-weekdays]');
      var calPrev = root.querySelector('[data-meeting-cal-prev]');
      var calNext = root.querySelector('[data-meeting-cal-next]');
      var timezoneSelect = root.querySelector('[data-meeting-timezone]');
      var statusEl = root.querySelector('[data-meeting-status]');
      var errorEl = root.querySelector('[data-meeting-error]');
      var submitButton = root.querySelector('[data-meeting-submit]');
      var submitLabelEl = root.querySelector('[data-meeting-submit-label]');
      var required = root.getAttribute('data-meeting-required') === 'true';
      var disableWeekends = root.getAttribute('data-meeting-disable-weekends') === 'true';
      var minDateValue = root.getAttribute('data-meeting-min-date') || '';
      var redirectCheckout = root.getAttribute('data-meeting-redirect-checkout') === 'true';
      var checkoutUrl = root.getAttribute('data-meeting-checkout-url') || '/checkout';
      var dateKey = root.getAttribute('data-date-key');
      var timeKey = root.getAttribute('data-time-key');
      var timezoneKey = root.getAttribute('data-timezone-key');
      var locationKey = root.getAttribute('data-location-key');
      var locationValue = root.getAttribute('data-location-value') || 'Google Meet';
      var errorRequired = root.getAttribute('data-error-required') || '';
      var errorUnavailable = root.getAttribute('data-error-unavailable') || '';
      var errorSave = root.getAttribute('data-error-save') || '';
      var bookedSlotsDisplay = root.getAttribute('data-meeting-booked-slots-display') || 'hide';
      var bookedEmptyMessage = root.getAttribute('data-booked-empty') || '';
      var bookedLabelText = root.getAttribute('data-booked-label') || 'Booked';
      var slotsEmptyEl = root.querySelector('[data-meeting-slots-empty]');
      var submittingLabel = root.getAttribute('data-submitting-label') || 'Saving…';
      var weekdayLabels = (root.getAttribute('data-weekday-labels') || 'Sun,Mon,Tue,Wed,Thu,Fri,Sat')
        .split(',')
        .map(function (label) {
          return label.trim();
        });
      var defaultSubmitLabel = submitLabelEl ? submitLabelEl.textContent : '';
      var saveTimer = null;
      var submitting = false;
      var viewYear = null;
      var viewMonth = null;

      function parseBookedSlotsPayload() {
        var el = root.querySelector('[data-meeting-booked-slots]');
        if (!el) return { dates: [] };
        try {
          var raw = (el.textContent || '').trim();
          if (!raw) return { dates: [] };
          var parsed = JSON.parse(raw);
          if (typeof parsed === 'string') parsed = JSON.parse(parsed);
          return parsed && typeof parsed === 'object' ? parsed : { dates: [] };
        } catch (e) {
          return { dates: [] };
        }
      }

      function normalizeSlotLabel(value) {
        return String(value || '')
          .replace(/[\u00a0\u202f\u2007\u2060]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();
      }

      function formatTimeLabel(date, timezone) {
        try {
          return new Intl.DateTimeFormat('en-US', {
            timeZone: timezone || 'America/New_York',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
          }).format(date);
        } catch (e) {
          return '';
        }
      }

      function slotMatchKeys(slot, fallbackTimezone) {
        var keys = {};
        function add(value) {
          var normalized = normalizeSlotLabel(value);
          if (normalized) keys[normalized] = true;
        }

        if (!slot) return keys;
        add(slot.label);

        // From range labels like "2:30-3:00 PM", also index "2:30 pm"
        var labelNorm = normalizeSlotLabel(slot.label);
        var rangeMatch = labelNorm.match(/^(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})\s*(am|pm)$/);
        if (rangeMatch) {
          add(rangeMatch[1] + ' ' + rangeMatch[3]);
        } else {
          var singleMatch = labelNorm.match(/^(\d{1,2}:\d{2})\s*(am|pm)$/);
          if (singleMatch) add(singleMatch[1] + ' ' + singleMatch[2]);
        }

        var timezone = slot.timezone || fallbackTimezone || 'America/New_York';
        if (slot.start_time) {
          var start = new Date(slot.start_time);
          if (!isNaN(start.getTime())) {
            var startLabel = formatTimeLabel(start, timezone);
            add(startLabel);
            if (slot.end_time) {
              var end = new Date(slot.end_time);
              if (!isNaN(end.getTime())) {
                var endLabel = formatTimeLabel(end, timezone);
                if (startLabel && endLabel) {
                  add(startLabel.replace(/\s*(AM|PM)$/i, '') + '-' + endLabel);
                  add(startLabel + '-' + endLabel);
                }
              }
            }
          }
        }
        return keys;
      }

      function buildBookedByDate(payload) {
        var map = {};
        var dates = (payload && payload.dates) || [];
        var fallbackTimezone = (payload && payload.timezone) || 'America/New_York';
        dates.forEach(function (entry) {
          if (!entry || !entry.date) return;
          var key = String(entry.date).slice(0, 10);
          if (!map[key]) map[key] = {};
          (entry.slots || []).forEach(function (slot) {
            var keys = slotMatchKeys(slot, fallbackTimezone);
            Object.keys(keys).forEach(function (matchKey) {
              map[key][matchKey] = true;
            });
          });
        });
        return map;
      }

      var bookedByDate = buildBookedByDate(parseBookedSlotsPayload());
      var bookedSlotsLiveUrl = root.getAttribute('data-meeting-booked-slots-url') || '';
      var bookedRefreshTimer = null;

      function mergeBookedByDate(nextMap) {
        Object.keys(nextMap || {}).forEach(function (dateKey) {
          if (!bookedByDate[dateKey]) bookedByDate[dateKey] = {};
          Object.keys(nextMap[dateKey] || {}).forEach(function (slotKey) {
            bookedByDate[dateKey][slotKey] = true;
          });
        });
      }

      function refreshBookedSlotsFromLive() {
        if (!bookedSlotsLiveUrl) return Promise.resolve();
        var url =
          bookedSlotsLiveUrl +
          (bookedSlotsLiveUrl.indexOf('?') >= 0 ? '&' : '?') +
          'tpa_slots=' +
          Date.now();
        return fetch(url, {
          method: 'GET',
          credentials: 'same-origin',
          headers: { Accept: 'application/json, text/plain, */*' },
          cache: 'no-store'
        })
          .then(function (res) {
            if (!res.ok) throw new Error('live slots fetch failed');
            return res.text();
          })
          .then(function (text) {
            var raw = String(text || '').trim();
            // Page may wrap JSON; extract first {...} block.
            var start = raw.indexOf('{');
            var end = raw.lastIndexOf('}');
            if (start === -1 || end === -1 || end < start) return;
            var parsed = JSON.parse(raw.slice(start, end + 1));
            if (typeof parsed === 'string') parsed = JSON.parse(parsed);
            if (!parsed || typeof parsed !== 'object') return;
            bookedByDate = buildBookedByDate(parsed);
            root.setAttribute('data-meeting-booked-slots-source', 'live');
            updateBookedTimeSlots();
          })
          .catch(function () {
            /* keep embedded metafield payload */
          });
      }

      function startBookedSlotsAutoRefresh() {
        refreshBookedSlotsFromLive();
        clearInterval(bookedRefreshTimer);
        bookedRefreshTimer = setInterval(refreshBookedSlotsFromLive, 5000);
      }

      function stopBookedSlotsAutoRefresh() {
        clearInterval(bookedRefreshTimer);
        bookedRefreshTimer = null;
      }

      function bookedLabelsForDate(dateValue) {
        if (!dateValue) return {};
        return bookedByDate[String(dateValue).slice(0, 10)] || {};
      }

      function radioStartKey(radioValue, displayLabel) {
        var range = normalizeSlotLabel(radioValue || displayLabel);
        var m = range.match(/^(\d{1,2}:\d{2})\s*-\s*\d{1,2}:\d{2}\s*(am|pm)$/);
        if (m) return normalizeSlotLabel(m[1] + ' ' + m[2]);
        var s = range.match(/^(\d{1,2}:\d{2})\s*(am|pm)$/);
        if (s) return normalizeSlotLabel(s[1] + ' ' + s[2]);
        return '';
      }

      function isSlotBooked(booked, radioValue, displayLabel) {
        var candidates = [
          radioValue,
          displayLabel,
          String(radioValue || '').split('-')[0],
          radioStartKey(radioValue, displayLabel)
        ];
        for (var i = 0; i < candidates.length; i++) {
          var key = normalizeSlotLabel(candidates[i]);
          if (key && booked[key]) return true;
        }
        return false;
      }

      function originalSlotLabel(labelEl, radio) {
        if (labelEl && labelEl.getAttribute('data-original-label')) {
          return labelEl.getAttribute('data-original-label');
        }
        return radio ? radio.value : '';
      }

      function updateBookedTimeSlots() {
        var dateValue = dateInput ? dateInput.value : '';
        var booked = bookedLabelsForDate(dateValue);
        var visibleCount = 0;

        root.querySelectorAll('[data-meeting-slot]').forEach(function (slotEl) {
          var radio = slotEl.querySelector('[data-meeting-time]');
          var labelEl = slotEl.querySelector('[data-meeting-slot-label]');
          if (!radio) return;

          if (labelEl && !labelEl.getAttribute('data-original-label')) {
            labelEl.setAttribute('data-original-label', labelEl.textContent || radio.value);
          }

          var original = originalSlotLabel(labelEl, radio);
          var isBooked = isSlotBooked(booked, radio.value, original);

          slotEl.classList.remove('is-booked', 'is-booked-hidden');
          radio.disabled = false;
          radio.removeAttribute('aria-disabled');
          if (labelEl) labelEl.textContent = original;

          if (!dateValue || !isBooked) {
            slotEl.hidden = false;
            visibleCount += 1;
            return;
          }

          if (radio.checked) radio.checked = false;

          if (bookedSlotsDisplay === 'disable') {
            slotEl.classList.add('is-booked');
            slotEl.hidden = false;
            radio.disabled = true;
            radio.setAttribute('aria-disabled', 'true');
            if (labelEl) {
              labelEl.textContent = original + ' (' + bookedLabelText + ')';
            }
            visibleCount += 1;
          } else {
            slotEl.classList.add('is-booked-hidden');
            slotEl.hidden = true;
          }
        });

        // Drop a cart-prefilled selection if that slot is now booked.
        var checked = root.querySelector('[data-meeting-time]:checked');
        if (checked && checked.disabled) {
          checked.checked = false;
        }
        checked = root.querySelector('[data-meeting-time]:checked');
        if (checked) {
          var checkedLabel = checked.closest('[data-meeting-slot]');
          var labelNode = checkedLabel
            ? checkedLabel.querySelector('[data-meeting-slot-label]')
            : null;
          var originalChecked = originalSlotLabel(labelNode, checked);
          if (isSlotBooked(booked, checked.value, originalChecked)) {
            checked.checked = false;
          }
        }

        if (slotsEmptyEl) {
          var showEmpty = !!dateValue && visibleCount === 0;
          slotsEmptyEl.hidden = !showEmpty;
          if (showEmpty && bookedEmptyMessage) {
            slotsEmptyEl.textContent = bookedEmptyMessage;
          }
        }
      }

      function parseDateValue(value) {
        if (!value) return null;
        var parts = String(value).split('-').map(Number);
        if (parts.length < 3 || !parts[0] || !parts[1] || !parts[2]) return null;
        return new Date(parts[0], parts[1] - 1, parts[2]);
      }

      function formatDateValue(date) {
        var y = date.getFullYear();
        var m = String(date.getMonth() + 1).padStart(2, '0');
        var d = String(date.getDate()).padStart(2, '0');
        return y + '-' + m + '-' + d;
      }

      function parseDisabledDates(raw) {
        var set = {};
        String(raw || '')
          .split(/[\s,;]+/)
          .forEach(function (token) {
            var match = String(token).match(/(\d{4}-\d{2}-\d{2})/);
            if (match) set[match[1]] = true;
          });
        return set;
      }

      var disabledDates = parseDisabledDates(root.getAttribute('data-meeting-disabled-dates'));
      var minDate = parseDateValue(minDateValue) || new Date();
      minDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());

      function isWeekendDate(date) {
        if (!date) return false;
        var day = date.getDay();
        return day === 0 || day === 6;
      }

      function isHolidayDate(date) {
        if (!date) return false;
        return !!disabledDates[formatDateValue(date)];
      }

      function isDateUnavailable(date) {
        if (!date) return true;
        var dayOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (dayOnly < minDate) return true;
        if (disableWeekends && isWeekendDate(dayOnly)) return true;
        if (isHolidayDate(dayOnly)) return true;
        return false;
      }

      function nextAvailableDate(date) {
        var next = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        var guard = 0;
        while (isDateUnavailable(next) && guard < 370) {
          next.setDate(next.getDate() + 1);
          guard += 1;
        }
        return next;
      }

      function enforceAvailableSelection(showMessage) {
        if (!dateInput || !dateInput.value) return false;
        var selected = parseDateValue(dateInput.value);
        if (!selected || !isDateUnavailable(selected)) return false;
        var adjusted = nextAvailableDate(selected < minDate ? minDate : selected);
        dateInput.value = formatDateValue(adjusted);
        viewYear = adjusted.getFullYear();
        viewMonth = adjusted.getMonth();
        renderCalendar();
        formatDay();
        updateBookedTimeSlots();
        if (showMessage && errorUnavailable) showError(errorUnavailable);
        return true;
      }

      function showError(message) {
        if (!errorEl) return;
        if (message) {
          errorEl.textContent = message;
          errorEl.hidden = false;
        } else {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
      }

      function showStatus(message) {
        if (!statusEl) return;
        if (message) {
          statusEl.textContent = message;
          statusEl.hidden = false;
        } else {
          statusEl.hidden = true;
          statusEl.textContent = '';
        }
      }

      function formatDay() {
        if (!dateInput || !dayLabel) return;
        if (!dateInput.value) {
          dayLabel.textContent = '';
          return;
        }
        var date = parseDateValue(dateInput.value);
        if (!date) {
          dayLabel.textContent = '';
          return;
        }
        dayLabel.textContent = date.toLocaleDateString(undefined, {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        });
      }

      function renderWeekdayLabels() {
        if (!calWeekdays) return;
        calWeekdays.innerHTML = '';
        weekdayLabels.forEach(function (label) {
          var span = document.createElement('span');
          span.textContent = label || '';
          calWeekdays.appendChild(span);
        });
      }

      function selectDate(value, showMessage) {
        if (!dateInput) return;
        var date = parseDateValue(value);
        if (!date) return;
        if (isDateUnavailable(date)) {
          if (showMessage && errorUnavailable) showError(errorUnavailable);
          return;
        }
        showError('');
        dateInput.value = formatDateValue(date);
        viewYear = date.getFullYear();
        viewMonth = date.getMonth();
        renderCalendar();
        formatDay();
        updateBookedTimeSlots();
        scheduleSave();
      }

      function renderCalendar() {
        if (!calGrid || viewYear === null || viewMonth === null) return;

        if (calTitle) {
          calTitle.textContent = new Date(viewYear, viewMonth, 1).toLocaleDateString(undefined, {
            month: 'long',
            year: 'numeric'
          });
        }

        var firstDay = new Date(viewYear, viewMonth, 1);
        var startWeekday = firstDay.getDay();
        var daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
        var selectedValue = dateInput ? dateInput.value : '';
        var todayValue = formatDateValue(new Date());

        calGrid.innerHTML = '';

        for (var i = 0; i < startWeekday; i++) {
          var empty = document.createElement('button');
          empty.type = 'button';
          empty.className = 'meeting-schedule__cal-day is-outside';
          empty.tabIndex = -1;
          empty.setAttribute('aria-hidden', 'true');
          empty.disabled = true;
          calGrid.appendChild(empty);
        }

        for (var day = 1; day <= daysInMonth; day++) {
          var date = new Date(viewYear, viewMonth, day);
          var value = formatDateValue(date);
          var unavailable = isDateUnavailable(date);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'meeting-schedule__cal-day';
          btn.textContent = String(day);
          btn.setAttribute('data-meeting-cal-day', value);
          btn.setAttribute('aria-label', date.toLocaleDateString(undefined, {
            weekday: 'long',
            month: 'long',
            day: 'numeric'
          }));

          if (value === todayValue) btn.classList.add('is-today');
          if (value === selectedValue) {
            btn.classList.add('is-selected');
            btn.setAttribute('aria-pressed', 'true');
          } else {
            btn.setAttribute('aria-pressed', 'false');
          }

          if (unavailable) {
            btn.classList.add('is-disabled');
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
          } else {
            btn.addEventListener('click', function (event) {
              selectDate(event.currentTarget.getAttribute('data-meeting-cal-day'), true);
            });
          }

          calGrid.appendChild(btn);
        }

        if (calPrev) {
          var prevMonthEnd = new Date(viewYear, viewMonth, 0);
          calPrev.disabled = prevMonthEnd < minDate;
        }
      }

      function initCalendarView() {
        var selected = parseDateValue(dateInput && dateInput.value);
        var seed = selected && !isDateUnavailable(selected) ? selected : nextAvailableDate(minDate);
        viewYear = seed.getFullYear();
        viewMonth = seed.getMonth();
        renderWeekdayLabels();
        renderCalendar();
      }

      function selectedTime() {
        var checked = root.querySelector('[data-meeting-time]:checked:not(:disabled)');
        return checked ? checked.value : '';
      }

      function isComplete() {
        if (!required) return true;
        if (!(dateInput && dateInput.value && selectedTime())) return false;
        var selected = parseDateValue(dateInput.value);
        if (isDateUnavailable(selected)) return false;
        var booked = bookedLabelsForDate(dateInput.value);
        if (isSlotBooked(booked, selectedTime(), selectedTime())) return false;
        return true;
      }

      function collectAttributes() {
        var attrs = {};
        if (dateKey && dateInput) attrs[dateKey] = dateInput.value || '';
        if (timeKey) attrs[timeKey] = selectedTime();
        if (timezoneKey && timezoneSelect) attrs[timezoneKey] = timezoneSelect.value || '';
        if (locationKey) attrs[locationKey] = locationValue;
        if (dateInput && dateInput.value && selectedTime()) {
          attrs.tpa_schedule_complete = 'yes';
        }
        return attrs;
      }

      function saveAttributes() {
        var attrs = collectAttributes();
        return fetch(routesCartUpdate, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ attributes: attrs })
        }).then(function (res) {
          if (!res.ok) throw new Error('save failed');
          return res.json();
        });
      }

      function scheduleSave() {
        if (submitting) return;
        showError('');
        clearTimeout(saveTimer);
        saveTimer = setTimeout(function () {
          if (!dateInput.value && !selectedTime()) return;
          saveAttributes()
            .then(function () {
              showStatus('');
              root.dispatchEvent(
                new CustomEvent('meeting-schedule:saved', {
                  bubbles: true,
                  detail: collectAttributes()
                })
              );
            })
            .catch(function () {
              showError(errorSave);
            });
        }, 250);
      }

      function setSubmitting(state) {
        submitting = state;
        if (!submitButton) return;
        submitButton.disabled = state;
        if (submitLabelEl) {
          submitLabelEl.textContent = state ? submittingLabel : defaultSubmitLabel;
        }
      }

      function unlockForm() {
        setSubmitting(false);
        root.querySelectorAll(
          'input:not([data-meeting-cal-day]):not([data-meeting-time]), select, [data-meeting-submit], [data-meeting-cal-prev], [data-meeting-cal-next]'
        ).forEach(function (el) {
          el.disabled = false;
          el.removeAttribute('aria-disabled');
        });
        renderCalendar();
        updateBookedTimeSlots();
      }

      function applySavedTime(savedTime) {
        if (!savedTime) return;
        var radios = Array.prototype.slice.call(root.querySelectorAll('[data-meeting-time]'));
        var exact = radios.find(function (radio) {
          return radio.value === savedTime;
        });
        if (exact) {
          exact.checked = true;
          return;
        }

        // Match legacy "9:00 AM" values to "9:00-9:30 AM" slots.
        var legacy = savedTime.replace(/\s+/g, ' ').trim();
        var fuzzy = radios.find(function (radio) {
          var value = radio.value.replace(/\s+/g, ' ').trim();
          if (value.indexOf(legacy) === 0) return true;
          var start = value.split('-')[0].trim();
          var period = (value.match(/\b(AM|PM)\b/i) || [])[0] || '';
          var startWithPeriod = (start + (period ? ' ' + period : '')).replace(/\s+/g, ' ').trim();
          return startWithPeriod.toLowerCase() === legacy.toLowerCase();
        });
        if (fuzzy) fuzzy.checked = true;
      }

      function handleSubmit() {
        showError('');
        showStatus('');

        if (enforceAvailableSelection(true)) {
          scheduleSave();
          return;
        }

        if (!isComplete()) {
          showError(errorRequired);
          return;
        }

        setSubmitting(true);
        clearTimeout(saveTimer);

        saveAttributes()
          .then(function () {
            try {
              sessionStorage.setItem('tpa_schedule_visited', '1');
            } catch (e) {}

            root.dispatchEvent(
              new CustomEvent('meeting-schedule:saved', {
                bubbles: true,
                detail: collectAttributes()
              })
            );
            root.dispatchEvent(
              new CustomEvent('meeting-schedule:submitted', {
                bubbles: true,
                detail: collectAttributes()
              })
            );

            if (redirectCheckout) {
              window.location.href = checkoutUrl;
              return;
            }

            unlockForm();
            showStatus('');
          })
          .catch(function () {
            unlockForm();
            showError(errorSave);
          });
      }

      function prefillFromCart() {
        return fetch(routesCart, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store'
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            if (!cart || !cart.attributes) return;
            unlockForm();
            if (dateInput && cart.attributes[dateKey]) {
              dateInput.value = cart.attributes[dateKey];
              enforceAvailableSelection(false);
            }
            if (timezoneSelect && cart.attributes[timezoneKey]) {
              timezoneSelect.value = cart.attributes[timezoneKey];
            }
            applySavedTime(cart.attributes[timeKey]);
            initCalendarView();
            formatDay();
            updateBookedTimeSlots();
          })
          .catch(function () {
            unlockForm();
          });
      }

      if (calPrev) {
        calPrev.addEventListener('click', function () {
          viewMonth -= 1;
          if (viewMonth < 0) {
            viewMonth = 11;
            viewYear -= 1;
          }
          renderCalendar();
        });
      }
      if (calNext) {
        calNext.addEventListener('click', function () {
          viewMonth += 1;
          if (viewMonth > 11) {
            viewMonth = 0;
            viewYear += 1;
          }
          renderCalendar();
        });
      }
      if (timezoneSelect) {
        timezoneSelect.addEventListener('change', scheduleSave);
      }
      root.querySelectorAll('[data-meeting-time]').forEach(function (radio) {
        radio.addEventListener('change', scheduleSave);
      });
      if (submitButton) {
        submitButton.addEventListener('click', handleSubmit);
      }

      if (dateInput && dateInput.value) {
        enforceAvailableSelection(false);
      }
      initCalendarView();
      formatDay();
      updateBookedTimeSlots();
      unlockForm();
      prefillFromCart();
      startBookedSlotsAutoRefresh();

      document.addEventListener('pa-modal:opened', function () {
        startBookedSlotsAutoRefresh();
      });

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') refreshBookedSlotsFromLive();
        else stopBookedSlotsAutoRefresh();
      });

      root.__meetingSchedule = {
        isComplete: isComplete,
        saveAttributes: saveAttributes,
        collectAttributes: collectAttributes,
        showError: showError,
        errorRequired: errorRequired,
        handleSubmit: handleSubmit,
        unlockForm: unlockForm,
        prefillFromCart: prefillFromCart,
        refreshBookedSlots: refreshBookedSlotsFromLive
      };
    }

    function initAll() {
      document.querySelectorAll('[data-meeting-schedule]').forEach(initPicker);
    }

    function guardCheckout(event) {
      var roots = document.querySelectorAll('[data-meeting-schedule]');
      if (!roots.length) return;

      var incomplete = null;
      roots.forEach(function (root) {
        if (root.__meetingSchedule && !root.__meetingSchedule.isComplete()) {
          incomplete = root;
        }
      });

      if (!incomplete) return;

      event.preventDefault();
      event.stopPropagation();
      if (incomplete.__meetingSchedule) {
        incomplete.__meetingSchedule.showError(incomplete.__meetingSchedule.errorRequired);
      }
      incomplete.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function restoreAfterReturn() {
      document.querySelectorAll('[data-meeting-schedule]').forEach(function (root) {
        if (!root.__meetingSchedule) return;
        root.__meetingSchedule.unlockForm();
        root.__meetingSchedule.prefillFromCart();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
    window.addEventListener('pageshow', restoreAfterReturn);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') restoreAfterReturn();
    });

    document.addEventListener(
      'click',
      function (event) {
        var checkout = event.target.closest('[name="checkout"], [data-cart-checkout]');
        if (!checkout) return;
        guardCheckout(event);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents, moneyFormat) {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
      return (Number(cents) / 100).toFixed(2);
    }

    document.querySelectorAll('.product-form__form').forEach(function (form) {
      var section = form.closest('[data-product-section]') || form.closest('.shopify-section');
      if (!section) return;
      var jsonEl = section.querySelector('[data-product-json]');
      if (!jsonEl) return;
      var variants = [];
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (error) {
        return;
      }

      var idInput = form.querySelector('[data-variant-id]');
      var atc = form.querySelector('[data-product-atc]');
      var atcLabel = form.querySelector('[data-atc-label]');
      var priceEl = section.querySelector('[data-product-price]');
      var compareEl = section.querySelector('[data-product-compare]');
      var optionInputs = form.querySelectorAll('[data-option-input], [data-option-select]');

      function selectedOptions() {
        var values = [];
        form.querySelectorAll('[data-option-index]').forEach(function (group) {
          var select = group.querySelector('[data-option-select]');
          if (select) {
            values.push(select.value);
            return;
          }
          var checked = group.querySelector('[data-option-input]:checked');
          values.push(checked ? checked.value : '');
        });
        return values;
      }

      function findVariant(options) {
        return variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === options[index];
          });
        });
      }

      function updateMedia(mediaId) {
        if (!mediaId) return;
        section.querySelectorAll('[data-product-media]').forEach(function (media) {
          media.classList.toggle('is-active', String(media.getAttribute('data-media-id')) === String(mediaId));
        });
        section.querySelectorAll('[data-thumb-id]').forEach(function (thumb) {
          thumb.classList.toggle('is-active', String(thumb.getAttribute('data-thumb-id')) === String(mediaId));
        });
      }

      function update() {
        if (!optionInputs.length) return;
        var variant = findVariant(selectedOptions());
        if (!variant) return;
        idInput.value = variant.id;
        var moneyFormat = section.getAttribute('data-money-format');
        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price, moneyFormat);
        }
        if (compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareEl.hidden = false;
            compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          } else {
            compareEl.hidden = true;
          }
        }
        if (atc) atc.disabled = !variant.available;
        if (atcLabel) {
          atcLabel.textContent = variant.available
            ? atcLabel.getAttribute('data-add')
            : atcLabel.getAttribute('data-sold');
        }
        var mediaId = variant.featured_media && variant.featured_media.id;
        updateMedia(mediaId);
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('change', update);
      });

      form.querySelectorAll('[data-qty-change]').forEach(function (button) {
        button.addEventListener('click', function () {
          var field = form.querySelector('.product-form__qty-input');
          if (!field) return;
          var next = Number(field.value || 1) + Number(button.getAttribute('data-qty-change'));
          field.value = Math.max(1, next);
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    gallery.querySelectorAll('[data-thumb-id]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-thumb-id');
        gallery.querySelectorAll('[data-product-media]').forEach(function (media) {
          media.classList.toggle('is-active', media.getAttribute('data-media-id') === id);
        });
        gallery.querySelectorAll('[data-thumb-id]').forEach(function (item) {
          item.classList.toggle('is-active', item === thumb);
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
